const LOAD_DATA_JOB_OPENING_STATUS           = 'LOAD_DATA_JOB_OPENING_STATUS'
const LOAD_DATA_JOB_OPENING_STATUS_SUCCESS   = 'LOAD_DATA_JOB_OPENING_STATUS_SUCCESS'
const LOAD_DATA_JOB_OPENING_STATUS_FAILED    = 'LOAD_DATA_JOB_OPENING_STATUS_FAILED'
const UNMOUNT_DATA_JOB_OPENING_STATUS        = 'UNMOUNT_DATA_JOB_OPENING_STATUS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobOpeningStatusReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOB_OPENING_STATUS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_JOB_OPENING_STATUS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_JOB_OPENING_STATUS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_JOB_OPENING_STATUS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobOpeningStatusReducer;